export function acceptHot(importMeta, moduleObject) {
    const hot = importMeta?.hot || moduleObject?.hot;
    if (hot?.accept) {
        hot.accept();
    }
}
